import React from "react";

export default function Preview() {
    return (
        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.49992 14.6663H10.4999C13.8333 14.6663 15.1666 13.333 15.1666 9.99967V5.99967C15.1666 2.66634 13.8333 1.33301 10.4999 1.33301H6.49992C3.16659 1.33301 1.83325 2.66634 1.83325 5.99967V9.99967C1.83325 13.333 3.16659 14.6663 6.49992 14.6663Z" stroke="#3375F5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8.9 12.333H11.4333C12.4333 12.333 12.8333 11.933 12.8333 10.933V9.73301C12.8333 8.73301 12.4333 8.33301 11.4333 8.33301H8.9C7.9 8.33301 7.5 8.73301 7.5 9.73301V10.933C7.5 11.933 7.9 12.333 8.9 12.333Z" stroke="#3375F5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}